const ExtractDataForSelect=()=>{
    
}

export const removeArabic=(str)=>{
    if(str==null) return "";
    let newStr = str.replace(/[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF]+/g, "").replace(/\s+,/g, ",");
    return newStr.replace(/^,|,$/g, "").trim();
}